export default {"src":"https://kroemtech.ch//_next/static/media/kroemtech_logo_dark.4e4d7695.svg","height":92,"width":519,"blurWidth":0,"blurHeight":0};